<template>
  <div>
    <div class="item">
      <div class="label">推荐内容如下</div>
      <a-card size="small" :loading="loading">
        <a-row :gutter="[10,10]">
          <a-col :span="4">资源类型</a-col>
          <a-col :span="20" class="content">
            {{ recommendData.type }}
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="4">推荐资源</a-col>
          <a-col :span="20" class="content">
            <div v-for="record in recommendData.tableRecordList" :key="record.key" class="recordItem">
              <span class="item-label">{{ record.key }}：</span> <span class="item-value">{{ Array.isArray(record.value) ? record.value.join(', ') : record.value ? record.value : '暂无'}}</span>
            </div>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="4">附件</a-col>
          <a-col :span="20" class="content">
            <div v-for="annex in recommendData.annexList" :key="annex.key" class="recordItem">
              <a :href="annex.value">{{ annex.key }}</a>
            </div>
          </a-col>
        </a-row>
      </a-card>
    </div>
    <template v-if="pageType !== 'info'">
      <div class="item">
        <div class="label">推荐理由</div>
        <a-textarea :autoSize="{ minRows: 3, maxRows: 9 }" v-model="reason"></a-textarea>
      </div>

      <div class="item">
        <div class="label">推荐人</div>
        <select-member width="100%" :multiple="true" :userlist="userList" @delChosenUser="deleteUser" @chose="choseUser"></select-member>
      </div>

      <div class="footer">
        <div class="tips">点击发送则会给选择用户发送飞书卡片</div>
        <a-button class="footer-button" type="primary" @click="submit">发送</a-button>
      </div>
    </template>
  </div>
</template>
<style lang="less" scoped>
.label {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 10px;
}
.item {
  margin-bottom: 20px;
}
.content {
  display: flex;
  flex-wrap: wrap;
}
.recordItem {
  margin: 0 50px 5px 0px;
  .item-label {
    margin-right: 5px;
    opacity: .7;
  }
  .item-value {
    
  }
}
.footer {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  .tips {
    font-size: 12px;
    margin: 10px 0;
  }
  .footer-button {
  }
}
</style>
<script>
import { recommend, queryRecommendData } from '@/api/humint';
import selectMember from '@/components/project/selectMember.vue';
export default {
  components: {
    selectMember
  },
  data() {
    return {
      userList: [],
      loading: false,
      submitLoading: false,
      type: 'info',
      reason: '',
      appToken: '',
      tableId: '',
      recordId: '',
      recommendData: {
        tableRecordList: [],
        annexList: [],
        type: ''
      }
    };
  },
  computed: {
    pageType() {
      return this.type;
    }
  },

  mounted() {
    this.appToken = this.$route.query.appToken;
    this.tableId = this.$route.query.tableId;
    this.recordId = this.$route.query.recordId;
    this.type = this.$route.query.type;
    this.getRecommend();
  },
  methods: {
    async getRecommend() {
      try {
        this.loading = true;
        let res = await queryRecommendData({
          appToken: this.appToken,
          tableId: this.tableId,
          recordId: this.recordId
        });
        if (res.code === 200) {
          console.log(res);
          this.recommendData = res.data;
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.loading = false;
      }
    },
    choseUser(users) {
      this.userList = users;
    },
    deleteUser(user) {
      this.userList = this.userList.filter(item => item.id !== user.id);
    },
    async submit() {
      
      if (!this.userList.length) {
        this.$message.error('请选择推荐人');
        return;
      }
      try {
        if (this.submitLoading) return;
        this.submitLoading = true;
        let res = await recommend({
          reason: this.reason,
          userIds: this.userList.map(item => item.id),
          resource: this.recommendData,
          appToken: this.appToken,
          tableId: this.tableId,
          recordId: this.recordId
        });
        if (res.code === 200) {
          this.$message.success('推荐成功');
          this.$router.push('/humint/clue');
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.submitLoading = false;
      }
    }
  }
};
</script>
